import { useContext } from 'react';
import { OrganizationalUnitContext } from 'contexts/organizationalUnitContext/OrganizationalUnitContext';

export const useOrganizationalUnitContext = () => {
	return useContext(OrganizationalUnitContext);
};
